import React, { FC } from 'react'

import { Txt } from 'src/components/atoms'

export const ProjectStatusTooltipContent: FC = () => {
  return (
    <Txt sizeType="s">
      <strong>停止中</strong>
      <br />
      ROOV compassすべての機能が利用不可。
      <br />
      <br />
      <strong>アーカイブ</strong>
      <br />
      「ROOV compassプレゼンツール」のお客様への
      <br />
      シェア利用不可。
      <br />
      管理画面の利用不可。
      <br />
      ※有償オプションとなります。
      <br />
      <br />
      <strong>準備中</strong>
      <br />
      「ROOV compassプレゼンツール」のお客様への
      <br />
      シェア利用不可。
      <br />
      「マーケティング支援」プランをご利用の場合に「標
      <br />
      準登録フォーム」によるお客様へのシェア利用不可。
      <br />
      <br />
      <strong>稼働中</strong>
      <br />
      ROOV compassすべての機能が利用可能。
    </Txt>
  )
}
